import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';

const BasicDetails = (props) => {

    // const handleChange = (e,param) => {

    //     props.setData(data => {
    //         const newdata = [...data['employeeMaster']]
    //         newdata[0][param] = e.target.value
    //         return({
    //             ...data,
    //             employeeMaster : newdata
    //         })
    //     })
    // }
    const handleChange = (e, param) => {
        let value = e.target.value;
        
        // Aadhar number validation
        if (param === "adhar_no") {
            // Remove non-numeric characters and limit to 12 digits
            value = value.replace(/\D/g, '').slice(0, 12);
        }
    
        props.setData(data => {
            const newdata = [...data['employeeMaster']]
            newdata[0][param] = value
            return {
                ...data,
                employeeMaster: newdata
            }
        })
    }
    

    const handleSChange = (val,param) => {

        props.setData(data => {
            const newdata = [...data['employeeMaster']]
            newdata[0][param] = val
            return({
                ...data,
                employeeMaster : newdata
            })
        })
    }


    return(
        <div>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            {/* {!props.create && <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="EMPLOYEE CODE" param="employee_code" value={props.data.employee_code} />} */}
            <DataField editMode={props.editMode} lg={props.create ? 24 : 12} md={24} handleChange={handleChange} name="First Name" required={true} param="employee_name" value={props.data.employee_name} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Middle Name" param="employee_mname" value={props.data.employee_mname} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Last Name" param="employee_lname" value={props.data.employee_lname} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Company Email" required={true} param="email" value={props.data.email} />
            {/* <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.UNIT_CODE} type="Select" name="SITE" param="unit_code" value={props.data.unit_code} /> */}
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.EMPLOYEE_DESIG_CODE} type="Select" name="Designation" param="employee_desig_code" value={props.data.employee_desig_code} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Aadhar No" required={true} param="adhar_no" value={props.data.adhar_no} />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.EMPLOYEE_DEPT_CODE} type="Select" name="Department" param="employee_dept_code" value={props.data.employee_dept_code} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="HOD" param="hod" value={props.data.hod} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.EMPLOYEE_GRADE_CODE} type="Select" name="Grade" param="employee_grade_code" value={props.data.employee_grade_code} />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Experience" param="experience" value={props.data.experience} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.QUALIFICATIONS} type="Select" name="Qualification" param="qualifications" value={props.data.qualifications} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Current CTC" required={true} param="ctc" value={props.data.ctc} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Gross Salary" required={true} param="gross_salary" value={props.data.gross_salary} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.RWS} type="Select" name="PF Given or Not" param="pf_req" value={props.data.pf_req} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.EMPLOYEE_TYPE_CODE} type="Select" name="EMP Type" required={true} param="employee_type_code" value={props.data.employee_type_code} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Salary Norm" param="salary_norm_code" value={props.data.salary_norm_code} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Account Code" param="acc_group_code" value={props.data.acc_group_code} />
        </Row>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.SHIFT} required={true} type="Select" name="Shift" param="shift" value={props.data.shift} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.REST_DAY} type="Select" name="Rest Day" param="rest_day" value={props.data.rest_day} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Casual Leave" param="casual_lv" value={props.data.casual_lv} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Earned Leave" param="earned_lv" value={props.data.earned_lv} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Limit" param="limit" value={props.data.limit} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleSChange} options={props.ad.RWS} type="Select" name="Overtime" param="overtime" value={props.data.overtime} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Tolerance" param="tolerance" value={props.data.tolerance} />
            <DataField editMode={props.editMode} lg={12} md={24} handleChange={handleChange} name="Validity Days" param="validity_days" value={props.data.validity_days} />
        </Row>
        <p></p>
    </div>
    
    );
}

export default BasicDetails